/* eslint-disable no-console */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import sdkAnalyticsConfigurator from './app/libs/analytics';

if (environment.production) {
	enableProdMode();
}

sdkAnalyticsConfigurator.apply().then(() =>
	platformBrowserDynamic()
		.bootstrapModule(AppModule)
		.catch((err) => console.error(err)),
);
